import * as yup from 'yup';

export const booleanOptional: Validator<?boolean> = yup.boolean().nullable();

export const booleanRequired: Validator<?boolean> = yup.boolean().required();
